import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { listCompletedSurveys } from '../api/reportsApi'

// Quick-download landing list. ONE server call per page — the backend sorts by
// most-recent and paginates, so there's no client-side fan-out. `entityId`
// undefined = all visible entities; a value narrows server-side. Infinite query
// accumulates pages for "Show more"; getNextPageParam reads the server's
// `has_next` so we never over-page. keepPreviousData keeps the current list
// visible while switching entity filters instead of flashing empty.
export interface CompletedSurveysQueryArgs {
  entityId?: string | undefined
}

export const completedSurveysQueryOptions = (
  { entityId }: CompletedSurveysQueryArgs = {},
) =>
  infiniteQueryOptions({
    queryKey: ['reports', 'completed', entityId ?? 'all'] as const,
    queryFn: ({ pageParam }) => listCompletedSurveys({ entityId, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.has_next ? lastPage.pagination.current_page + 1 : undefined,
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  })

export function useCompletedSurveys(args: CompletedSurveysQueryArgs = {}) {
  return useInfiniteQuery(completedSurveysQueryOptions(args))
}
